<!--上下题 -->
<template>
    <div class="changeWork">
        <img class="changeWork-icon" :src="isLeftDisabled ? require('@/assets/images/homeWork/left-disable.png') : require('@/assets/images/homeWork/left.png')" @click="curQuestionNum == 0 ? '' : handleClick('left')" alt="" />
        <img class="changeWork-icon" :src="isRightDisabled ?  require('@/assets/images/homeWork/right-disable.png') : require('@/assets/images/homeWork/right.png')" @click="curQuestionNum == questionList.length - 1 ? '' : handleClick('right')" alt="" />
    </div>
</template>

<script>
export default {
    name: 'ChangeWork',
    props: {
        questionList: {
            type: Array,
            default: () => []
        },
        curQuestionNum: {
            type: Number,
            default: 0
        }
    },
    computed: {
        isLeftDisabled() {
            return this.curQuestionNum === 0
        },
        isRightDisabled() {
            return this.curQuestionNum === this.questionList.length - 1
        },
    },
    methods: {
        handleClick(direction) {
            this.$emit('handleClick', direction)
        }
    },
}
</script>

<style lang="scss" scoped>
.changeWork {
    display: flex;
    justify-content: space-between;
    .changeWork-icon {
        width: 32px;
        height: 32px;
    }
}
</style>